export const WELCOME = "/";
export const PLAY = "/play";
